import { render, staticRenderFns } from "./DmsManage.vue?vue&type=template&id=61c801eb&"
import script from "./DmsManage.vue?vue&type=script&lang=js&"
export * from "./DmsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports